import { render, staticRenderFns } from "./product_sort.vue?vue&type=template&id=69b89ab1&scoped=true"
import script from "./product_sort.vue?vue&type=script&lang=js"
export * from "./product_sort.vue?vue&type=script&lang=js"
import style0 from "./product_sort.vue?vue&type=style&index=0&id=69b89ab1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b89ab1",
  null
  
)

export default component.exports